/**
 * @generated SignedSource<<5f6bf41150819ce455d89fa06fc5f893>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateTradeOfferErrorCode = "INVESTMENT_NORMAL_LIMIT_REACHED" | "INVESTMENT_ZERO_LIMIT_REACHED";
export type OrderOperation = "BUY" | "SELL";
export type CreateOrderInput = {
  amount: any;
  assetId: string;
  expiresAt?: TimeScalar | null | undefined;
  fiatId?: string | null | undefined;
  operation: OrderOperation;
  targetPrice: any;
};
export type CreateOrderMutation$variables = {
  input?: CreateOrderInput | null | undefined;
};
export type CreateOrderMutation$data = {
  readonly createOrder: {
    readonly __typename: "CreateTradeOfferError";
    readonly code: CreateTradeOfferErrorCode;
    readonly details: {
      readonly currentInvestedAmount: PrecisionFloat | null | undefined;
      readonly maxLimitAmount: PrecisionFloat | null | undefined;
      readonly remainingBalanceAmount: PrecisionFloat | null | undefined;
      readonly requestedAmount: PrecisionFloat | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "Order";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CreateOrderFragment">;
  } | {
    readonly __typename: "OrderSignatureNeeded";
    readonly deepLink: string;
    readonly order: {
      readonly id: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type CreateOrderMutation = {
  response: CreateOrderMutation$data;
  variables: CreateOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deepLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Order",
      "kind": "LinkedField",
      "name": "order",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "type": "OrderSignatureNeeded",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreateTradeOfferErrorDetails",
      "kind": "LinkedField",
      "name": "details",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requestedAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentInvestedAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxLimitAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingBalanceAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreateTradeOfferError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createOrder",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateOrderFragment"
              }
            ],
            "type": "Order",
            "abstractKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createOrder",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "operation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "targetPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetAmount",
                "storageKey": null
              }
            ],
            "type": "Order",
            "abstractKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v4/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c2917c5b072f4eb1113c4e3a41cf96f8",
    "id": null,
    "metadata": {},
    "name": "CreateOrderMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrderMutation(\n  $input: CreateOrderInput\n) {\n  createOrder(input: $input) {\n    __typename\n    ... on Order {\n      id\n      ...CreateOrderFragment\n    }\n    ... on OrderSignatureNeeded {\n      deepLink\n      order {\n        id\n      }\n    }\n    ... on CreateTradeOfferError {\n      code\n      details {\n        requestedAmount\n        currentInvestedAmount\n        maxLimitAmount\n        remainingBalanceAmount\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment CreateOrderFragment on Order {\n  id\n  operation\n  status\n  targetPrice\n  fiatAmount\n  assetAmount\n}\n"
  }
};
})();

(node as any).hash = "cce17fe2ac00c02fc75023f8cd662ea5";

export default node;
